import { User, UserType } from '@nemuru-eng/js-api-client';
import { Dispatch, SetStateAction } from 'react';
import { SWRConfig } from 'swr';

import { AddUserForm } from '@/components/shared/components/UserList/components/UserActionsTableDialog/components/AddUserForm';
import { BlockAllUsersMessage } from '@/components/shared/components/UserList/components/UserActionsTableDialog/components/BlockAllUsersMessage';
import { SpyUserMessage } from '@/components/shared/components/UserList/components/UserActionsTableDialog/components/SpyUserMessage';
import { UserTableActionType } from '@/components/shared/components/UserList/types/UserTableActionType';

interface UserActionsTableDialogProps {
  userType: UserType;
  userId: string;
  users?: User[];
  userAction: UserTableActionType;
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  toggleDialog: () => void;
  revalidate: () => Promise<any>;
}

export const UserActionsTableDialog = ({
  userType,
  userId,
  users,
  userAction,
  opened,
  setOpened,
  toggleDialog,
  revalidate,
}: UserActionsTableDialogProps) => {
  return (
    <>
      <SWRConfig value={{ revalidateOnMount: false }}>
        {userAction === UserTableActionType.ADD_USER && (
          <AddUserForm
            userId={userId}
            userType={userType}
            opened={opened}
            setOpened={setOpened}
            handleClose={toggleDialog}
            revalidate={revalidate}
          />
        )}
        {userAction === UserTableActionType.BLOCK_ALL_USERS && users && (
          <BlockAllUsersMessage
            userId={userId}
            users={users}
            opened={opened}
            setOpened={setOpened}
            handleClose={toggleDialog}
          />
        )}
        {userAction === UserTableActionType.SPY_USER && (
          <SpyUserMessage
            userId={userId}
            userType={userType}
            opened={opened}
            setOpened={setOpened}
            handleClose={toggleDialog}
          />
        )}
      </SWRConfig>
    </>
  );
};
